export interface AppVersionMeta {
  version: string;
}

const META_URL = '/assets/meta.json';

export class AppVersionService {
  async getDeployedVersion(): Promise<AppVersionMeta> {
    const response = await fetch(META_URL, { cache: 'no-store' });
    if (!response.ok) {
      throw new Error(`meta.json fetch failed with status ${response.status}`);
    }
    const data = (await response.json()) as Partial<AppVersionMeta>;
    if (typeof data.version !== 'string') {
      throw new Error('meta.json missing string version field');
    }
    return { version: data.version };
  }
}
